import { render, staticRenderFns } from "./ConsentPage.vue?vue&type=template&id=ba089574&scoped=true"
import script from "./ConsentPage.vue?vue&type=script&lang=js"
export * from "./ConsentPage.vue?vue&type=script&lang=js"
import style0 from "./ConsentPage.vue?vue&type=style&index=0&id=ba089574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba089574",
  null
  
)

export default component.exports